exports = module.exports = require("../../../../../landing-page/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".spinner.loading-indicator {\n  width: 28px;\n  margin: 0 auto;\n  padding: 12px 0;\n}\n\n.spinner .dot1,\n.spinner .dot2 {\n  background: #606671;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/alextaxiera/source/farmhand-server/client/landing-page/~/css-loader!/Users/alextaxiera/source/farmhand-server/client/landing-page/~/postcss-loader/lib?{"plugins":[null]}!/Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/components/loading-indicator/index.css
// module id = ../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js?{"plugins":[null]}!../../../dashboard/src/js/components/loading-indicator/index.css
// module chunks = 0